import { useDarkModeContext } from "@/lib/client/contexts/DarkModeContext";
import clsx from "clsx";

import { useShallow } from "zustand/react/shallow";
import { useLauncherStore } from "../lib/client/contexts/LauncherStoreContext";

export default function AppContainer({ children }: { children: React.ReactNode }) {
  const { isDarkMode } = useDarkModeContext();
  const { isFullscreen, isOpen, showLauncherButton } = useLauncherStore(
    useShallow((state) => ({
      isFullscreen: state.isFullscreen,
      isOpen: state.isOpen,
      showLauncherButton: state.showLauncherButton,
    })),
  );

  return (
    <div
      className={clsx(
        "appContainer",
        "flex h-full flex-col justify-end gap-8 overflow-hidden",
        "antialiased",
        isDarkMode && "dark",
        (!isFullscreen || (isFullscreen && !isOpen)) && "p-[32px]",
        // If opening or closing the chat from the launcher button and the viewport is not big enough to display the widget
        // In this case we switch to fullscreen mode so need to animate the padding
        "transistion-[padding] duration-300",
        isFullscreen && !showLauncherButton && !isOpen ? "delay-300" : "delay-0",
      )}
    >
      {children}
    </div>
  );
}
